import {post, get, put} from '@/utils/request';


export const Carousel = {
    list: (data) => get('/system/carousel/page', data),
    add: (data) => post('/system/carousel/add', data),
    update: (data) => put('/system/carousel/edit', data),
    detail: (id) => get(`/system/carousel/detail/${id}`, null),
    deletes: (data) => post(`/system/carousel/del`, data)
}

export const TcCooperated = {
    list: (data) => get('/system/tc-cooperated/page', data),
    dispose: (data) => post(`/system/tc-cooperated/dispose`, data)
}

export const Feedback = {
    list: (data) => get('/system/feedback/page', data),
    dispose: (data) => post(`/system/feedback/dispose`, data)
}

export const Reporting = {
    list: (data) => get('/system/reporting/page', data),
    dispose: (data) => post(`/system/reporting/dispose`, data)
}
